import { HttpStatusCode } from 'axios';

export const getFilenameFromContentDisposition = (header?: string, prefix = 'Export') => {
    if (!header) return `${prefix}_${new Date().toISOString()}.xlsx`;
    const match = header.match(/filename\s*=\s*"([^"]+)"|filename\s*=\s*([^;]+)/i);
    if (match) {
        const filename = match[1] || match[2];
        return filename.trim().replace(/^"|"$/g, '');
    }
    return `${prefix}_${new Date().toISOString()}.xlsx`;
};

/**
 * Accepts an axios-like response (or Blob), will parse Forbidden blob message if any,
 * or trigger download for blob payload. showToast is a callback to display errors.
 */
export const downloadBlobResponse = async (response: any, showToast: (err: any) => void, defaultPrefix = 'Export') => {
    try {
        const status = response?.status ?? null;
        if (status === HttpStatusCode.Forbidden || status === 403) {
            // try to parse message from blob body
            let message = 'You are not authorized to export data.';
            try {
                const errBlob = response?.data ?? response;
                if (errBlob && typeof errBlob.text === 'function') {
                    const text = await errBlob.text();
                    try {
                        const json = JSON.parse(text);
                        message = json?.message || text || message;
                    } catch {
                        message = text || message;
                    }
                }
            } catch {
                /* ignore parsing errors */
            }
            showToast({ code: 'Forbidden', message });
            return;
        }

        const blobData: Blob = response?.data ?? response;
        const headers = response?.headers ?? {};
        const contentDisposition = headers['content-disposition'] || headers['Content-Disposition'];
        const filename = getFilenameFromContentDisposition(contentDisposition, defaultPrefix);

        const blob = blobData instanceof Blob ? blobData : new Blob([blobData], { type: headers['content-type'] || 'application/octet-stream' });

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    } catch (e) {
        showToast({ code: 'Error', message: 'Failed to export data' });
    }
};